<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<div>
		<vs-dropdown class="cursor-pointer">
			<a class="flex items-center cursor-pointer" href.prevent>
				<i class="nucleo nucleo-dots text-xl cursor-pointer"></i>
			</a>

			<vs-dropdown-menu class="dropdown-sort-todo">
				<div class="dropdown-sort-todo--content">
					<ul class="">
						<li v-for="(sort, index) in sorts" :key="index">
							<vs-checkbox class="my-2 mx-3" v-model="form.sorts" :vs-value="sort" :checked="sort.checked">{{ $t(sort.label) }}</vs-checkbox>
						</li>
					</ul>
				</div>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
export default {
	name: "ColumnContextMenu",
	data() {
		return {
			form: {
				sorts: []
			},
			sorts: [],
			map: {}
		};
	},
	watch: {
		form: {
			handler: function(data) {
				if (Array.isArray(data.sorts)) {
					data.sorts.forEach(item => {
						if (localStorage) {
							let key = `STORE_REQ_${item.column}`;
							localStorage.setItem(key, item.checked ? '' : '1');
						}
					})
				}
				this.getData();
				this.$emit("onChangeSort", this.map);
			},
			deep: true
		}
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			let map = {}
			let data = [
				{ label: 'Code', column: "code"},
				{ label: 'Proposer', column: "requester", checked: '1'},
				{ label: 'RequestType', column: "reqtype", checked: '1' },
				{ label: 'Purpose', column: "request_reason", checked: '1' },
				{ label: 'CreatedDate', column: "created_at", checked: '1' },
				{ label: 'Status', column: "reqstatus", checked: '1' },
				{ label: 'Number', column: "number" },
			];
			
			data.forEach(item => {
				let key = `STORE_REQ_${item.column}`;
				let value = null;
				if (localStorage) {
					value = localStorage.getItem(key);
					if (value != null) {
						item.checked = value ? '1' : '';
					}
				}
				map[item.column] = item.checked;
			})
			this.sorts = data;
			this.map = map;
		}
	},
};
</script>
<style lang="scss">
.dropdown-sort-todo .dropdown-sort-todo--content {
	min-width: 14rem;
}
</style>
